import { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import {
  CHAIN_ORDER_STATUS_TEXT,
  ORDER_STATUS,
  ORDER_STATUS_TEXT,
} from 'utils';
import { genOrderStatus } from 'utils/function';

import { Wrapper } from './styles';

const OrderStatus = ({
  status,
  padding,
  fontSize,
  label,
  width,
  styles,
}: OrderStatusProps): JSX.Element => {
  const history = useHistory();
  const [orderStatus, setOrderStatus] = useState<any>({});

  const ORDER_STATUS_TEXT_VALUE = ORDER_STATUS_TEXT;

  useEffect(() => {
    const getData = () => {
      const data = genOrderStatus(status, ORDER_STATUS_TEXT_VALUE);

      if ((history?.location?.pathname ?? '').includes('sale')) {
        if (status == ORDER_STATUS.SUPPLIER_CONFIRM) {
          setOrderStatus({
            ...data,
            name: CHAIN_ORDER_STATUS_TEXT[ORDER_STATUS.SUPPLIER_CONFIRM],
          });

          return;
        }

        if (status == ORDER_STATUS.SUPPLIER_DRAFT) {
          setOrderStatus({
            ...data,
            name: 'Bản nháp của bạn',
          });
          return;
        }
      }

      if (
        (history?.location?.pathname ?? '').includes('purchase') ||
        (history?.location?.pathname ?? '').includes('buying')
      ) {
        if (status == ORDER_STATUS.CUSTOMER_CONFIRM) {
          setOrderStatus({
            ...data,
            name: CHAIN_ORDER_STATUS_TEXT[ORDER_STATUS.CUSTOMER_CONFIRM],
          });
          return;
        }

        if (status == ORDER_STATUS.CUSTOMER_DRAFT) {
          setOrderStatus({
            ...data,
            name: 'Bản nháp của bạn',
          });
          return;
        }
      }

      setOrderStatus({
        ...data,
      });
    };

    getData();
  }, [status]);

  return (
    <Wrapper
      background={orderStatus.color}
      fontSize={fontSize}
      padding={padding}
      width={width}
    >
      {label || orderStatus.name}
    </Wrapper>
  );
};

export default OrderStatus;

interface OrderStatusProps {
  status: number;
  padding?: string;
  fontSize?: string;
  label?: string;
  width?: string;
  styles?: any;
}
